var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableiconheadgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21046"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5321",
    x: 1.25,
    y: 1.25,
    width: 17.5,
    height: 17.5,
    rx: 8.75,
    fill: "#0DA06E",
    stroke: "#0DA06E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1622",
    d: "M5 10H15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableiconheadgreen);
export default __webpack_public_path__ + "static/media/tableiconheadgreen.7b27c8552d048e7f977653c75e824880.svg";
export { ForwardRef as ReactComponent };